import { useState, useEffect, useCallback } from 'react';
import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// components
import Scrollbar from '../../components/scrollbar';
import ProjectTaskListTable from './details/components/projectTaskList/ProjectTaskListTable';

// services
import { getProjectById } from '../../services/projectService';
import Loading from '../../layouts/loading';

// ----------------------------------------------------------------------

function ProjectDetails() {
  const { id } = useParams();
  const [projectDetails, setprojectDetails] = useState({});
  const [isLoading, setLoading] = useState(false);

  const fetchProjectDetails = useCallback(async () => {
    setLoading(true);
    try {
      const Projects = await getProjectById(id);
      setprojectDetails(Projects?.data?.data);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchProjectDetails();
  }, [fetchProjectDetails]);

  const queryClient = new QueryClient();

  return (
    <>
      <Scrollbar>
        {/* Task List Table */}
        <Grid>
          <QueryClientProvider client={queryClient}>
            <ProjectTaskListTable projectName={projectDetails?.projectName} />
          </QueryClientProvider>
        </Grid>
      </Scrollbar>

      <Loading open={isLoading} />
    </>
  );
}
export default ProjectDetails;
